// =============================================================================
// MUNSELL RENK ADLARI (Hue + Value/Chroma -> Türkçe renk adı)
// =============================================================================
// Kaynak: Munsell Soil Color Charts.
// Kartta karşılığı OLMAYAN birleşimler bilerek listeye alınmamıştır; böyle bir
// kod sorulursa getMunsellRenkAdi() boş string döner (uydurma ad üretmez).
//
// Hue değerleri MUNSELL_HUE_OPTIONS, kodlar MUNSELL_VALUE_CHROMA_OPTIONS ile
// aynı kaynaktan gelir (bkz. constants/horizonConstants.js).
// =============================================================================

// --- 1. KIRMIZI SAYFALARI: 5R, 7.5R ve 10R aynı renk adlarını paylaşır -------
const R_SAYFASI = {
  "8/1": "beyaz",
  "8/2": "pembemsi beyaz",
  "8/3": "pembe",
  "8/4": "pembe",
  "7/1": "açık kırmızımsı gri",
  "7/2": "soluk kırmızı",
  "7/3": "soluk kırmızı",
  "7/4": "soluk kırmızı",
  "7/6": "açık kırmızı",
  "7/8": "açık kırmızı",
  "6/1": "kırmızımsı gri",
  "6/2": "soluk kırmızı",
  "6/3": "soluk kırmızı",
  "6/4": "soluk kırmızı",
  "6/6": "açık kırmızı",
  "6/8": "açık kırmızı",
  "5/1": "kırmızımsı gri",
  "5/2": "zayıf kırmızı",
  "5/3": "zayıf kırmızı",
  "5/4": "zayıf kırmızı",
  "5/6": "kırmızı",
  "5/8": "kırmızı",
  "4/1": "koyu kırmızımsı gri",
  "4/2": "zayıf kırmızı",
  "4/3": "zayıf kırmızı",
  "4/4": "zayıf kırmızı",
  "4/6": "kırmızı",
  "4/8": "kırmızı",
  "3/1": "koyu kırmızımsı gri",
  "3/2": "donuk kırmızı",
  "3/3": "donuk kırmızı",
  "3/4": "donuk kırmızı",
  "3/6": "koyu kırmızı",
  "2.5/1": "kırmızımsı siyah",
  "2.5/2": "çok donuk kırmızı",
};

// --- 2. 2.5 YR ---------------------------------------------------------------
const YR_2_5 = {
  "8/1": "beyaz",
  "8/2": "pembemsi beyaz",
  "8/3": "pembe",
  "8/4": "pembe",
  "7/1": "açık kırmızımsı gri",
  "7/2": "soluk kırmızı",
  "7/3": "açık kırmızımsı kahverengi",
  "7/4": "açık kırmızımsı kahverengi",
  "7/6": "açık kırmızı",
  "7/8": "açık kırmızı",
  "6/1": "kırmızımsı gri",
  "6/2": "soluk kırmızı",
  "6/3": "açık kırmızımsı kahverengi",
  "6/4": "açık kırmızımsı kahverengi",
  "6/6": "açık kırmızı",
  "6/8": "açık kırmızı",
  "5/1": "kırmızımsı gri",
  "5/2": "zayıf kırmızı",
  "5/3": "kırmızımsı kahverengi",
  "5/4": "kırmızımsı kahverengi",
  "5/6": "kırmızı",
  "5/8": "kırmızı",
  "4/1": "koyu kırmızımsı gri",
  "4/2": "zayıf kırmızı",
  "4/3": "kırmızımsı kahverengi",
  "4/4": "kırmızımsı kahverengi",
  "4/6": "kırmızı",
  "4/8": "kırmızı",
  "3/1": "koyu kırmızımsı gri",
  "3/2": "donuk kırmızı",
  "3/3": "koyu kırmızımsı kahverengi",
  "3/4": "koyu kırmızımsı kahverengi",
  "3/6": "koyu kırmızı",
  "2.5/1": "kırmızımsı siyah",
  "2.5/2": "çok donuk kırmızı",
  "2.5/3": "koyu kırmızımsı kahverengi",
  "2.5/4": "koyu kırmızımsı kahverengi",
};

// --- 3. 5 YR -----------------------------------------------------------------
const YR_5 = {
  "8/1": "beyaz",
  "8/2": "pembemsi beyaz",
  "8/3": "pembe",
  "8/4": "pembe",
  "8/6": "kırmızımsı sarı",
  "7/1": "açık gri",
  "7/2": "pembemsi gri",
  "7/3": "pembe",
  "7/4": "pembe",
  "7/6": "kırmızımsı sarı",
  "7/8": "kırmızımsı sarı",
  "6/1": "gri",
  "6/2": "pembemsi gri",
  "6/3": "açık kırmızımsı kahverengi",
  "6/4": "açık kırmızımsı kahverengi",
  "6/6": "kırmızımsı sarı",
  "6/8": "kırmızımsı sarı",
  "5/1": "gri",
  "5/2": "kırmızımsı gri",
  "5/3": "kırmızımsı kahverengi",
  "5/4": "kırmızımsı kahverengi",
  "5/6": "sarımsı kırmızı",
  "5/8": "sarımsı kırmızı",
  "4/1": "koyu gri",
  "4/2": "koyu kırmızımsı gri",
  "4/3": "kırmızımsı kahverengi",
  "4/4": "kırmızımsı kahverengi",
  "4/6": "sarımsı kırmızı",
  "3/1": "çok koyu gri",
  "3/2": "koyu kırmızımsı kahverengi",
  "3/3": "koyu kırmızımsı kahverengi",
  "3/4": "koyu kırmızımsı kahverengi",
  "2.5/1": "siyah",
  "2.5/2": "koyu kırmızımsı kahverengi",
};

// --- 4. 7.5 YR ---------------------------------------------------------------
const YR_7_5 = {
  "8/1": "beyaz",
  "8/2": "pembemsi beyaz",
  "8/3": "pembe",
  "8/4": "pembe",
  "8/6": "kırmızımsı sarı",
  "7/1": "açık gri",
  "7/2": "pembemsi gri",
  "7/3": "pembe",
  "7/4": "pembe",
  "7/6": "kırmızımsı sarı",
  "7/8": "kırmızımsı sarı",
  "6/1": "gri",
  "6/2": "pembemsi gri",
  "6/3": "açık kahverengi",
  "6/4": "açık kahverengi",
  "6/6": "kırmızımsı sarı",
  "6/8": "kırmızımsı sarı",
  "5/1": "gri",
  "5/2": "kahverengi",
  "5/3": "kahverengi",
  "5/4": "kahverengi",
  "5/6": "kuvvetli kahverengi",
  "5/8": "kuvvetli kahverengi",
  "4/1": "koyu gri",
  "4/2": "kahverengi",
  "4/3": "kahverengi",
  "4/4": "kahverengi",
  "4/6": "kuvvetli kahverengi",
  "3/1": "çok koyu gri",
  "3/2": "koyu kahverengi",
  "3/3": "koyu kahverengi",
  "3/4": "koyu kahverengi",
  "2.5/1": "siyah",
  "2.5/2": "çok koyu kahverengi",
  "2.5/3": "çok koyu kahverengi",
};

// --- 5. 10 YR ----------------------------------------------------------------
const YR_10 = {
  "8/1": "beyaz",
  "8/2": "çok soluk kahverengi",
  "8/3": "çok soluk kahverengi",
  "8/4": "çok soluk kahverengi",
  "8/6": "sarı",
  "8/8": "sarı",
  "7/1": "açık gri",
  "7/2": "açık gri",
  "7/3": "çok soluk kahverengi",
  "7/4": "çok soluk kahverengi",
  "7/6": "sarı",
  "7/8": "sarı",
  "6/1": "gri",
  "6/2": "açık kahverengimsi gri",
  "6/3": "soluk kahverengi",
  "6/4": "açık sarımsı kahverengi",
  "6/6": "kahverengimsi sarı",
  "6/8": "kahverengimsi sarı",
  "5/1": "gri",
  "5/2": "grimsi kahverengi",
  "5/3": "kahverengi",
  "5/4": "sarımsı kahverengi",
  "5/6": "sarımsı kahverengi",
  "5/8": "sarımsı kahverengi",
  "4/1": "koyu gri",
  "4/2": "koyu grimsi kahverengi",
  "4/3": "kahverengi",
  "4/4": "koyu sarımsı kahverengi",
  "4/6": "koyu sarımsı kahverengi",
  "3/1": "çok koyu gri",
  "3/2": "çok koyu grimsi kahverengi",
  "3/3": "koyu kahverengi",
  "3/4": "koyu sarımsı kahverengi",
  "3/6": "koyu sarımsı kahverengi",
  "2/1": "siyah",
  "2/2": "çok koyu kahverengi",
  "2.5/1": "siyah",
  "2.5/2": "çok koyu kahverengi",
};

// --- 6. 2.5 Y ----------------------------------------------------------------
const Y_2_5 = {
  "8/1": "beyaz",
  "8/2": "soluk sarı",
  "8/3": "soluk sarı",
  "8/4": "soluk sarı",
  "8/6": "sarı",
  "8/8": "sarı",
  "7/1": "açık gri",
  "7/2": "açık gri",
  "7/3": "soluk sarı",
  "7/4": "soluk sarı",
  "7/6": "sarı",
  "7/8": "sarı",
  "6/1": "gri",
  "6/2": "açık kahverengimsi gri",
  "6/3": "açık sarımsı kahverengi",
  "6/4": "açık sarımsı kahverengi",
  "6/6": "zeytuni sarı",
  "6/8": "zeytuni sarı",
  "5/1": "gri",
  "5/2": "grimsi kahverengi",
  "5/3": "açık zeytuni kahverengi",
  "5/4": "açık zeytuni kahverengi",
  "5/6": "açık zeytuni kahverengi",
  "4/1": "koyu gri",
  "4/2": "koyu grimsi kahverengi",
  "4/3": "zeytuni kahverengi",
  "4/4": "zeytuni kahverengi",
  "3/1": "çok koyu gri",
  "3/2": "çok koyu grimsi kahverengi",
  "2.5/1": "siyah",
};

// --- 7. 5 Y ------------------------------------------------------------------
const Y_5 = {
  "8/1": "beyaz",
  "8/2": "soluk sarı",
  "8/3": "soluk sarı",
  "8/4": "soluk sarı",
  "8/6": "sarı",
  "8/8": "sarı",
  "7/1": "açık gri",
  "7/2": "açık gri",
  "7/3": "soluk sarı",
  "7/4": "soluk sarı",
  "7/6": "sarı",
  "7/8": "sarı",
  "6/1": "gri",
  "6/2": "açık zeytuni gri",
  "6/3": "soluk zeytuni",
  "6/4": "soluk zeytuni",
  "6/6": "zeytuni sarı",
  "6/8": "zeytuni sarı",
  "5/1": "gri",
  "5/2": "zeytuni gri",
  "5/3": "zeytuni",
  "5/4": "zeytuni",
  "5/6": "zeytuni",
  "4/1": "koyu gri",
  "4/2": "zeytuni gri",
  "4/3": "zeytuni",
  "4/4": "zeytuni",
  "3/1": "çok koyu gri",
  "3/2": "koyu zeytuni gri",
  "2.5/1": "siyah",
};

// --- 8. RENKLİ SAYFALAR TABLOSU ---------------------------------------------
export const MUNSELL_RENK_ADLARI = {
  "5R": R_SAYFASI,
  "7.5R": R_SAYFASI,
  "10R": R_SAYFASI,
  "2.5YR": YR_2_5,
  "5YR": YR_5,
  "7.5YR": YR_7_5,
  "10YR": YR_10,
  "2.5Y": Y_2_5,
  "5Y": Y_5,
};

// --- 9. GLEY SAYFALARI -------------------------------------------------------
// Gley kodlarında sütun bilgisi kodun içinde gelir (örnek: "5/10G", "4/N").
// Renk adı yalnızca value'ya ve sütunun ait olduğu aileye bağlıdır.
export const GLEY1_SUTUNLARI = ["10Y", "5GY", "10GY", "10G", "5G"];
export const GLEY2_SUTUNLARI = ["5BG", "10BG", "5B", "10B", "5PB"];

const GLEY1_ADLARI = {
  8: "açık yeşilimsi gri",
  7: "açık yeşilimsi gri",
  6: "yeşilimsi gri",
  5: "yeşilimsi gri",
  4: "koyu yeşilimsi gri",
  3: "çok koyu yeşilimsi gri",
  2.5: "yeşilimsi siyah",
};

const GLEY2_ADLARI = {
  8: "açık mavimsi gri",
  7: "açık mavimsi gri",
  6: "mavimsi gri",
  5: "mavimsi gri",
  4: "koyu mavimsi gri",
  3: "çok koyu mavimsi gri",
  2.5: "mavimsi siyah",
};

const N_ADLARI = {
  8: "beyaz",
  7: "açık gri",
  6: "gri",
  5: "gri",
  4: "koyu gri",
  3: "çok koyu gri",
  2.5: "siyah",
};

// --- 10. YARDIMCILAR ---------------------------------------------------------

/** "7,5 YR" / "7.5 yr" -> "7.5YR" ; "GLEY 1" -> "GLEY1" */
export function normalizeHue(hue) {
  if (!hue) return "";
  return String(hue).toUpperCase().split(" ").join("").split(",").join(".");
}

function sayiMi(deger) {
  return deger !== "" && Number.isFinite(Number(deger));
}

/**
 * Hue + Value/Chroma kodundan renk adını döndürür.
 * Kartta karşılığı yoksa "" döner.
 *
 *   getMunsellRenkAdi("10 YR", "5/3")    -> "kahverengi"
 *   getMunsellRenkAdi("GLEY 1", "4/10G") -> "koyu yeşilimsi gri"
 *   getMunsellRenkAdi("5 R", "8/8")      -> ""   (kartta yok)
 */
export function getMunsellRenkAdi(hue, kod) {
  if (!kod) return "";

  const parcalar = String(kod).trim().split("/");
  if (parcalar.length < 2) return "";

  const value = parcalar[0].trim();
  const chroma = parcalar[1].trim().toUpperCase();

  // Gley/nötr kodları: chroma kısmı harf içerir (10G, 5BG, N ...)
  if (!sayiMi(chroma)) {
    if (chroma === "N") return N_ADLARI[value] || "";
    if (GLEY1_SUTUNLARI.indexOf(chroma) > -1) return GLEY1_ADLARI[value] || "";
    if (GLEY2_SUTUNLARI.indexOf(chroma) > -1) return GLEY2_ADLARI[value] || "";
    // "5G2" gibi standart dışı sonekler için uydurma ad üretmiyoruz.
    return "";
  }

  const sayfa = MUNSELL_RENK_ADLARI[normalizeHue(hue)];
  if (!sayfa) return "";
  return sayfa[value + "/" + chroma] || "";
}

/**
 * Çıktıda kullanılacak tam metin: "10 YR 5/3 (kahverengi)".
 * Renk adı bulunamazsa yalnızca kodu döndürür.
 */
export function getMunsellTamAd(hue, kod) {
  const hueMetin = hue ? String(hue).trim() : "";
  const kodMetin = kod ? String(kod).trim() : "";
  if (!kodMetin) return hueMetin;

  const ad = getMunsellRenkAdi(hue, kod);
  const kodlu = hueMetin ? hueMetin + " " + kodMetin : kodMetin;
  return ad ? kodlu + " (" + ad + ")" : kodlu;
}

export default MUNSELL_RENK_ADLARI;
